module.exports = __webpack_public_path__ + "static/media/mindshare-media-ireland.af7087aa.jpg";